import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';
import {FONTS} from '../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    maincontainer: {
      ...CommonStyles.half_min_width,
      ...CommonStyles.full_flex,
      backgroundColor: colors.background,
    },
    formView: {
      paddingBottom: 150,
      ...CommonStyles.ph_56,
      ...CommonStyles.full_flex,
    },
    signinRouteContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
      ...CommonStyles.mb_32,
    },
    buttonContainer: {
      backgroundColor: colors.surface,
      ...CommonStyles.flex_row,
      ...CommonStyles.justify_center,
      ...CommonStyles.pv_24,
      ...CommonStyles.ph_56,
      ...CommonStyles.absolute_pos,
      ...CommonStyles.b_0,
      ...CommonStyles.r_0,
      ...CommonStyles.l_0,
      borderTopWidth: 1,
      borderColor: colors.borderMuted,
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
    },
    verifyButton: {
      ...CommonStyles.full_flex,
      ...CommonStyles.ml_12,
      ...CommonStyles.max_width_292,
    },
    resendButton: {
      ...CommonStyles.full_flex,
      ...CommonStyles.mr_12,
      ...CommonStyles.max_width_292,
    },
    dotContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.mb_22,
    },
    marginLeftMinus4: {
      marginLeft: -4,
    },
    marginTopMinus3: {
      marginTop: -3,
    },
    doubleDot: {
      top: 1,
      marginLeft: -10,
    },
  });

export default makeStyles;
